export function parseQuery() {
    if (location.href.indexOf('#') > 0) {
        var arr_url = location.href.split('#');
        if (arr_url[0].indexOf('?') > 0) {
            var new_pattern = /\?([\s\S]*)#/;
            location.href = location.href.replace(new_pattern, '#');
        }
    }

    const res = {};
    const query = (location.href.split('?')[1] || '')
        .trim()
        .replace(/^(\?|#|&)/, '');

    if (!query) {
        return res;
    }

    query.split('&').forEach(param => {
        const parts = param.replace(/\+/g, ' ').split('=');
        const key = decodeURIComponent(parts.shift());
        const val = parts.length > 0 ? decodeURIComponent(parts.join('=')) : null;

        if (res[key] === undefined) {
            res[key] = val;
        } else if (Array.isArray(res[key])) {
            res[key].push(val);
        } else {
            res[key] = [res[key], val];
        }
    });

    return res;
}
